import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { IdentityService } from 'main/services/identity.service'
import { ShowInExplorerService } from 'media/services/showInExplorer.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class OpenViaFTPOp extends BaseOperation {
  icon = 'far fa-folder-open'
  showInOverflowMenu = true
  supportsDirs = true
  weight = 200

  constructor (
    private showInExplorer: ShowInExplorerService,
    private translate: TranslateService,
    private identity: IdentityService,
    private panel: PanelService,
  ) {
    super()
    this.label = translate.instant('Open via FTP')
  }

  isEnabledForDir (dir, _options) {
    return dir.present && this.identity.hasPermission('ftp:access') && !this.panel.active
  }

  async runForDir (dir, _options) {
    this.showInExplorer.openFTP(dir)
  }
}

MediaOperationsService.register(OpenViaFTPOp)
